// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-about-tsx": () => import("/Users/mihov/here/projects/my-react-app/src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-pages-index-tsx": () => import("/Users/mihov/here/projects/my-react-app/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

